/**
 * @file API配置文件
 * @author fengfaxia(fengfaxia@baidu.com))
 */

import _ from 'lodash';
import {geneRequester} from './actions/fetchAction';
import {envConfig} from './common/envConfig';


const host = envConfig().dwzDomain;
let api = {
    createUrl: '/admin/v2/create',
    queryUrl: '/admin/v2/query',
    queryUrlV3: '/api/v3/short-urls',
    getRegisterData: '/admin/v1/creation/daily',
    getRegisterTotal: '/admin/v1/creation/total',
    getRedirectData: '/admin/v1/redirection/daily',
    getUserInfo: '/api/v3/users/self',
    tokenAction: '/admin/v1/token'
};
_.each(api, (value, key) => api[key] = host + value);
export default geneRequester(api);
